module.exports = __webpack_public_path__ + "static/media/image_10.afa8b0ef.jpg";